export const getSlugUrl = (url: string) => {
  if (!url) {
    return url
  }
  return url.split(/[/]+/).pop()
}
